import Axios from 'axios';
import mondaySdk from 'monday-sdk-js';
const monday = mondaySdk();

const BASE_URL = import.meta.env.VITE_APPLICATION_HOST_API_URL;
const BASE_URL_V2 = import.meta.env.VITE_APPLICATION_HOST_API_URL_V2;
const IS_DEV = import.meta.env.VITE_IS_DEV;

export const axios = Axios.create({
  baseURL: BASE_URL,
  headers: {
    'ngrok-skip-browser-warning': IS_DEV === 'true' ? true : false,
  },
});

export const axios_v2 = Axios.create({
  baseURL: BASE_URL_V2,
  headers: {
    'ngrok-skip-browser-warning': IS_DEV === 'true' ? true : false,
  },
});

export const API = async (query: string, variables?: any) => {
  try {
    monday.setApiVersion('2025-10');
    const result = await monday.api(
      query,
      variables ? { variables } : undefined,
    );
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const getContext = async () => {
  try {
    const result = await monday.get('context');
    return result.data;
  } catch (error) {
    console.log(error);
  }
};

export const getSessionToken = async () => {
  try {
    const result = await monday.get('sessionToken');
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const getLocation = async () => {
  try {
    const result = await monday.get('location');
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const openPricingModal = async (shouldPayFirst = false) => {
  try {
    await monday.execute('openPlanSelection', {
      isInPlanSelection: shouldPayFirst,
    });
  } catch (err) {
    console.log(err);
  }
};

/**
 * @deprecated Use showToast from monday.ts instead
 */
export const showToast = async ({
  message,
  type,
  timeout = 5000,
}: {
  message: string;
  type: string;
  timeout?: number;
}) => {
  try {
    return await monday.execute('notice', {
      message,
      type,
      timeout,
    });
  } catch (error) {
    console.log(error);
  }
};
